import { createWebHistory, createRouter } from "vue-router";

let appname = process.env.VUE_APP_APPNAME;

const routes = [
    {
        path: "/",
        name: "welcome",
        component: () => import('@/views/Login'),
        meta: {
            title: `Welcome to ${appname}`,
            auth: false
        },
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: () => import('@/views/Dashboard'),
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                components: {
                    main: () => import('@/views/subviews/DashboardView')
                },
                meta: {
                    title: `Welcome to ${appname}`
                },
            },
            {
                path: "/hris",
                name: "hris",
                components: {
                    main: () => import('@/views/HRIS')
                },
                meta: {
                    title: `HRIS - ${appname}`
                },
            },
            {
                path: "/vuniversity",
                name: "vuniversity",
                components: {
                    main: () => import('@/views/Vuniversity')
                },
                meta: {
                    title: `Vuniversity - ${appname}`
                },
            },
            {
                path: "/vuniversity/:child_id",
                name: "vuniversity/:child_id",
                components: {
                    main: () => import('@/views/Vuniversity')
                },
                meta: {
                    title: `Vuniversity - ${appname}`
                },
            },
            {
                path: "/vikipedia",
                name: "vikipedia",
                components: {
                    main: () => import('@/views/Vikipedia')
                },
                meta: {
                    title: `Vikipedia - ${appname}`
                },
            },
            {
                path: "/vikipedia/:child_id",
                name: "vikipedia/:child_id",
                components: {
                    main: () => import('@/views/Vikipedia')
                },
                meta: {
                    title: `Vikipedia - ${appname}`
                },
            },
            {
                path: "/vikipedia/:child_id/:schild_id",
                name: "vikipedia/:child_id/:schild_id",
                components: {
                    main: () => import('@/views/Vikipedia')
                },
                meta: {
                    title: `Vikipedia - ${appname}`
                },
            },
            {
                path: "/performance",
                name: "performance",
                components: {
                    main: () => import('@/views/Performance')
                },
                meta: {
                    title: `Comparative Performance - ${appname}`
                },
            },
            {
                path: "/performance/:salesman_code",
                name: "performance/:salesman_code",
                components: {
                    main: () => import('@/views/PerformanceDetail')
                },
                meta: {
                    title: `Comparative Performance Detail - ${appname}`
                },
            },
            {
                path: "/backroom/:employee_id",
                name: "backroom/:employee_id",
                components: {
                    main: () => import('@/views/PerformanceBackroomDetail')
                },
                meta: {
                    title: `Backroom Performance Detail - ${appname}`
                },
            },
            {
                path: "/se/:salesman_code",
                name: "se/:salesman_code",
                components: {
                    main: () => import('@/views/PerformanceSEDetail')
                },
                meta: {
                    title: `Sales Engineer Performance Detail - ${appname}`
                },
            },
            {
                path: "/se/:salesman_code",
                name: "se/:salesman_code",
                components: {
                    main: () => import('@/views/PerformanceSEDetail')
                },
                meta: {
                    title: `Sales Engineer Performance Detail - ${appname}`
                },
            },
            {
                path: "/search",
                name: "search",
                components: {
                    main: () => import('@/views/Search')
                },
                meta: {
                    title: `Searcher - ${appname}`
                },
            },
            {
                path: "/appraisal",
                name: "appraisal",
                components: {
                    main: () => import('@/views/AppraisalSalesman')
                },
                meta: {
                    title: `Appraisal - ${appname}`
                },
            },
            {
                path: "/appraisal/:salesman_code/:year/:month",
                name: "appraisal_list",
                components: {
                    main: () => import('@/views/Appraisal')
                },
                meta: {
                    title: `Appraisal Details - ${appname}`
                },
            }
        ],
        meta: {
            auth: true
        }
    },
    {
        path: "/:pathMatch(.*)*",
        alias: ['/error'],
        name: "error",
        component: () => import('@/views/Error'),
        meta: {
            error: true,
            title: `404 not found - ${appname}`
        }
    }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
